module.exports = __webpack_public_path__ + "static/img/banner.a49196a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = Yz7+
// module chunks = 5